import WFacebookLikeComponent from '@wix/thunderbolt-elements/src/components/WFacebookLike/viewer/WFacebookLike';


const WFacebookLike = {
  component: WFacebookLikeComponent
};


export const components = {
  ['WFacebookLike']: WFacebookLike
};


// temporary export
export const version = "1.0.0"
